module.exports = __webpack_public_path__ + "static/img/c1.9353ed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/c1.jpg
// module id = RdTC
// module chunks = 11